<template lang="pug">
#about
    section.banner.position-relative
        div.picture
            img.img-fluid.small(src="img/banner/banner_about_mobile.jpg" alt="banner-about nanya")
            img.img-fluid.big(src="img/banner/banner_about.jpg" alt="banner-about nanya")
        div.mask_banner
        div.breadcrumb_block
            b-container
                b-breadcrumb(:items="breadcrumb_items")
        div.banner_h1
            h1 About us
    b-container.py-sm-5.slogan
        h1.text-center.font-weight-bolder.py-5.color_first The best quality from our 60 years experience
    section
        b-container
            div.history
                b-row.mb-5.animate__fadeInUp.animate__animated.animate__slow
                    b-col(cols="12" md="3").text-center
                        b-img(src="img/about/nanya_1.png" )
                    b-col(cols="12" md="9" align-self="center")
                        P.text-justify Nan Ya Plastics was founded on 1958 and started to manufacture rigid PVC film in 1972. Nan Ya has specialized in rigid PVC film division for 50 years, who is the leading manufacturer in innovation and quality consistency. PVC film is made from PVC resin and can be divided into rigid and flexible. Rigid PVC film is mainly used in  rigid packaging material. For the flexible film, plasticizers are added into the formulation which is suitable for automobile advertisement and pouch. 
                b-row.menu.mb-5.wow.animate__fadeInUp.animate__animated.animate__slow
                    b-col(cols="12" md="3").text-center
                        b-img(src="img/about/nanya_2.png" )
                    b-col(cols="12" md="9" align-self="center")
                        P.text-justify The raw material of Nan Ya’s rigid film is PVC(Polyvinyl Chloride) and PET(Polyethylene Terephthalate). The application could be used in thermoforming packaging, pharmaceutical packaging, cards printing, interior decoration, and lamination.
                b-row.menu.mb-5.wow.animate__fadeInUp.animate__animated.animate__slow
                    b-col(cols="12" md="3").text-center
                        b-img(src="img/about/nanya_3.png" )
                    b-col(cols="12" md="9" align-self="center")
                        P.text-justify The main production bases are located in Chiayi(Taiwan), Guangzhou(China), Nantong(China), and Texas(USA). Nan Ya has Awarded ISO 9001, ISO 14001, OHSAS18001, TOSHMS, FDA, TAF laboratory certification.
    section.py-5   
        b-container.philosophy.pb-0.pb-md-5
            b-row
                b-col(cols="12" md="6" data-wow-duration="2s").wow.animate_left.order-2.order-md-1
                    span.p-4.p-sm-5
                        h2.color_first Business Scope
                        p.py-4.text-justify Most three-stage plastic processing companies in Taiwan have relocated to mainland China and Southeast Asia where raw materials are locally available at cheaper prices, hence the decreasing demand on domestic two-stage processing products.
                            | To adapt to changing markets and external environmental factors, Nan Ya continues to transform and accelerate research and development of new applications, new materials, environmental trends and unique specifications to develop new niche markets, and actively strive to collaborate with international manufacturers in production, marketing and strategic alliances, combined with e-commerce and online marketing to vigorously expand high-end markets such as the U.S. and Japan and potential emerging markets.
                            | Through the development of manufacturing services to provide customer satisfaction and other efforts, plastic processing products can still maintain stable profits.
                b-col.pl-md-0(cols="12" md="6" align-self="center").wow.animate_right.order-1.order-md-2
                    b-img(src="img/about/fpg_chairman.jpg" fluid )
    section.future
        b-container
            div.mb-5.bgc_first
                div.position-relative
                    span
                        svg(viewBox="0 0 40 19" fill="#ffffff").quote.quote_before
                            path(d="M3.93925781,12.15 C1.31307281,11.1058542 1.38555833e-13,9.0808744 1.38555833e-13,6.075 C1.38555833e-13,4.30311614 0.672356558,2.84766195 2.01708984,1.70859375 C3.36182313,0.569525555 4.84100756,-1.77635684e-15 6.4546875,-1.77635684e-15 C8.28985293,-1.77635684e-15 9.79276758,0.66444648 10.9634766,1.99335938 C12.1341855,3.32227227 12.7195313,4.96756832 12.7195313,6.92929687 C12.7195313,10.5679869 9.93518409,14.5072054 4.36640625,18.7470703 L1.42382813,16.4689453 C2.62617789,14.7287022 3.46464606,13.2890682 3.93925781,12.15 Z" )
                            path(d="M30.9392578,12.15 C28.3130728,11.1058542 27,9.0808744 27,6.075 C27,4.30311614 27.6723566,2.84766195 29.0170898,1.70859375 C30.3618231,0.569525555 31.8410076,-1.77635684e-15 33.4546875,-1.77635684e-15 C35.2898529,-1.77635684e-15 36.7927676,0.66444648 37.9634766,1.99335938 C39.1341855,3.32227227 39.7195312,4.96756832 39.7195312,6.92929687 C39.7195312,10.5679869 36.9351841,14.5072054 31.3664062,18.7470703 L28.4238281,16.4689453 C29.6261779,14.7287022 30.4646461,13.2890682 30.9392578,12.15 Z")
                    h2.text-white Company Vision
                    p.text-white To Strengthen the globalization and diversification in related industries to reach the world scale and become the global leader. To continue deepening and specialization in these industries to adapt for the global change and ensure the stable and long-term growth of the company.
                    span
                        svg(viewBox="0 0 40 19" fill="#ffffff").quote.quote_after
                            path(d="M3.93925781,12.15 C1.31307281,11.1058542 1.38555833e-13,9.0808744 1.38555833e-13,6.075 C1.38555833e-13,4.30311614 0.672356558,2.84766195 2.01708984,1.70859375 C3.36182313,0.569525555 4.84100756,-1.77635684e-15 6.4546875,-1.77635684e-15 C8.28985293,-1.77635684e-15 9.79276758,0.66444648 10.9634766,1.99335938 C12.1341855,3.32227227 12.7195313,4.96756832 12.7195313,6.92929687 C12.7195313,10.5679869 9.93518409,14.5072054 4.36640625,18.7470703 L1.42382813,16.4689453 C2.62617789,14.7287022 3.46464606,13.2890682 3.93925781,12.15 Z" )
                            path(d="M30.9392578,12.15 C28.3130728,11.1058542 27,9.0808744 27,6.075 C27,4.30311614 27.6723566,2.84766195 29.0170898,1.70859375 C30.3618231,0.569525555 31.8410076,-1.77635684e-15 33.4546875,-1.77635684e-15 C35.2898529,-1.77635684e-15 36.7927676,0.66444648 37.9634766,1.99335938 C39.1341855,3.32227227 39.7195312,4.96756832 39.7195312,6.92929687 C39.7195312,10.5679869 36.9351841,14.5072054 31.3664062,18.7470703 L28.4238281,16.4689453 C29.6261779,14.7287022 30.4646461,13.2890682 30.9392578,12.15 Z")


</template>

<script>
export default {
    metaInfo: {
        title: 'About NAN YA-NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'The best quality from our 60 years experience.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, About NAN YA' },
            { name: 'og:title', content: 'About NAN YA-NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'The best quality from our 60 years experience.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
    data() {
        return {
            breadcrumb_items: [
                {
                    text: 'Home',
                    to: { name: 'App' }
                },
                {
                    text: 'ABOUT US',
                    active: true
                }
            ]
        }
    }
}
</script>

<style lang="sass">
.breadcrumb 
    background-color: transparent

.slogan
    h1
        @media all and ( max-width: 767px )
            font-size: 30px
        @media all and ( max-width: 576px )
            font-size: 20px
.history
    p
        line-height: 1.94
        letter-spacing: 0.96px
        padding-left: 5px
        padding-right: 5px
    img
        width: 100%
        @media all and ( max-width: 767px)
            width: 75%
            padding-bottom: 25px
            
.philosophy
    overflow: hidden
    .row
        div
            &:nth-child(1)
                padding-right: 0
                position: relative
                z-index: 10
                span
                    display: block
                    box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.5)
                    background-color: #fafafa
                    position: relative
                p
                    line-height: 1.94
                    letter-spacing: 0.96px
        @media all and ( max-width: 767px )
            div
                padding: 0
                span
                    margin: 0 20px -25px
                    top: -35px
                
.future 
    .bgc_first
        padding: 80px
    @media all and ( max-width: 991px )
        .container
            padding: 0
            .bgc_first
                padding: 50px 25px
        
.quote
    width: 42px
    height: 20px
    transform: rotate(180deg)
    position: absolute
.quote_before
    top: -30px
    left: 0
.quote_after
    bottom: -30px
    right: 16px
</style>